import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import studentReducer from './slices/studentSlice';
import teacherReducer from './slices/teacherSlice';
import lessonReducer from './slices/lessonSlice';
import classReducer from './slices/classSlice';
import lessonCategoryReducer from './slices/lessonCategorySlice';
import workspaceReducer from './slices/workspaceSlice';
import parentReducer from './slices/parentSlice';
import adminReducer from './slices/adminSlice';
import saleReducer from './slices/saleSlice';
import timerReducer from './slices/timerSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        students: studentReducer,
        teachers: teacherReducer,
        lessons: lessonReducer,
        classes: classReducer,
        lessonCategories: lessonCategoryReducer,
        workspace: workspaceReducer,
        parents: parentReducer,
        admins: adminReducer,
        sales: saleReducer,
        timer: timerReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
